const ReportOrder = {
  SER: 5,
  DER: 4,
  FER_Captain: 3,
  FER_First_Officer: 2,
  CER: 1,
  FON: 0,
};

export default ReportOrder;
